import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { homepageContent, siteContent } from '../../data/products';
import Icon from '../Icon/Icon';
import './BehindTheBakes.css';

const BehindTheBakes = () => {
  const reduce = useReducedMotion();
  const content = homepageContent.kitchenStory;

  return (
    <section id="behind-the-bakes" className="behind-bakes" aria-labelledby="behind-bakes-title">
      <div className="behind-bakes-inner">
        <motion.figure
          className="behind-bakes-media"
          initial={{ opacity: 0, y: reduce ? 0 : 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.65, ease: 'easeOut' }}
        >
          <img
            src={content.image}
            alt={content.imageAlt}
            loading="lazy"
            decoding="async"
          />
          <figcaption>{content.caption}</figcaption>
        </motion.figure>

        <motion.div
          className="behind-bakes-copy"
          initial={{ opacity: 0, y: reduce ? 0 : 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.65, ease: 'easeOut', delay: reduce ? 0 : 0.08 }}
        >
          <span className="behind-bakes-kicker">{content.eyebrow}</span>
          <h2 id="behind-bakes-title">
            {content.title} <em>{content.titleAccent}</em>
          </h2>
          <p>{content.body}</p>

          <div className="behind-bakes-facts" aria-label={`How ${siteContent.brand.name} bakes`}>
            {content.facts.map((fact) => (
              <span key={fact.label}><Icon name={fact.icon} size={18} /> {fact.label}</span>
            ))}
          </div>

          <a className="behind-bakes-link" href={content.reelUrl} target="_blank" rel="noreferrer">
            <Icon name="instagram" size={19} />
            <span>{content.reelLabel}</span>
            <Icon name="arrow" size={17} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default BehindTheBakes;
